"use strict";

import { Model } from "../model";
import { Objects } from "Constants/objects";
export var FormDetailsModel = Model.extend({
  initialize: function initialize() {
    this.object = Objects.SysSubForms;
  }
});